// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"41be9901","494":"ed4fba9c","528":"f5b06715","760":"4551d111","799":"85c90f9c"}[chunkId] + ".chunk.js";
};